(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.TOT",
            {
                url: "/TOT",
                component: "tipoftriangle",
                PageTitle: "Tip of the Triangle",
                requiredPermissions: "TipOfTheTriangle:View|TipOfTheTriangle:Access",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("tipoftriangle",
    {
        templateUrl: "App/Resources/TipOfTriangle/TOT.html",
        controller: totCtrl,
        bindings: {
            states: "<"
        }
    });

    totCtrl.$inject = ["$mdDialog", "$http", "$timeout", "$filter", "$scope", "$state", "wistiaApi", "permissionService", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "amplitudeService"];

    function totCtrl($mdDialog, $http, $timeout, $filter, $scope, $state, wistiaApi, permissionService, eligibilityFormDialog, surveys, eligibilityFormApi, amplitudeService) {

        var $ctrl = this; 

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $scope.$watch("$ctrl.submittedSurveyId", function (newValue) {
            console.log("$ctrl.submittedSurveyId", newValue);
            surveys.then(function (s) {
                if (newValue === s.affinityGroupId)
                    $ctrl.affinitySubmitted = true;

                if (newValue === s.figTalentSolutionsId)
                    $ctrl.talentSubmitted = true;
            });

        });

        surveys.then(function (s) {            
            eligibilityFormApi.isEnrolled(s.affinityGroupId).then(function (response) {
                $ctrl.affinitySubmitted = response;                
            });

            eligibilityFormApi.isEnrolled(s.figTalentSolutionsId).then(function (response) {
                $ctrl.talentSubmitted = response;                
            });
        });
      
        $ctrl.loadAffinityGroupResources = function () {
           
            $ctrl.loadingAssets = true;
            wistiaApi.getAffinityGroupAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);     
        }  

        if (permissionService.hasOnePermission("AffinityGroup:Access")) {
            $ctrl.loadAffinityGroupResources();
        }   

        /*  Open the Enrollment Form  */
        $ctrl.openAffinityDialog = function (event) {
          
            surveys.then(function (s) {
                
                eligibilityFormDialog.open(event, s.affinityGroupId).then(function (obj) {                   
                    ng.extend($ctrl, obj);
                });
            });
        }

        $ctrl.openTalentDialog = function (event) {
        
            surveys.then(function (s) {

                eligibilityFormDialog.open(event, s.figTalentSolutionsId).then(function (obj) {                    
                    ng.extend($ctrl, obj);
                });
            });
        }
    }   

})(window.app, window.angular); // jshint ignore:line